export default "__VITE_ASSET__BmHb9eza__"